import { Input } from '@mgmresorts/wcl-lab';
import React, { useContext, useMemo } from 'react';

import { useContent } from '../../../hooks/useContent';
import { MaxLengths } from '../../../utils/constants';
import { SignUpFormContext } from '../SignUpFormContext';
import { useFieldErrorAnalytics } from '../useFieldErrorAnalytics';

export function FirstName() {
  const { bindFirstName, isLoading, invalidFields } = useContext(SignUpFormContext);
  const { getContentByPath } = useContent();
  useFieldErrorAnalytics({ field: 'firstName', invalidFields });

  const error = useMemo(
    (): string | undefined =>
      invalidFields.includes('firstName') ? getContentByPath('accountCreation.fields.firstName.error') : undefined,
    [getContentByPath, invalidFields],
  );

  return (
    <Input
      label={getContentByPath('accountCreation.fields.firstName.title')}
      id='firstName'
      testId='firstName'
      disabled={isLoading}
      aria-label={getContentByPath('accountCreation.fields.firstName.label')}
      error={!!error}
      hint={error}
      className={`identity__field identity__field-firstName ${error ? 'with-error' : ''}`}
      {...bindFirstName}
      maxLength={MaxLengths.FirstName}
    />
  );
}

FirstName.displayName = 'FirstNameField';
